<template>
  <div>
    <el-select v-model="selectproject" placeholder="请选择" @change="clearcodedata">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div>
      <el-date-picker
        v-model="value2"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd 00:00:00"
      ></el-date-picker>
      <span v-if="selectproject === '试用锁记录'">
        <el-button slot="append" icon="el-icon-search" @click="Getcodemeter(value2)">试用查询</el-button>
        <el-button slot="append" icon="el-icon-download" @click="exporttrialrecord(value2)">试用导出</el-button>
      </span>
      <span v-else>
        <el-button slot="append" icon="el-icon-search" @click="Getcodemeter(value2)">正式查询</el-button>
        <el-button slot="append" icon="el-icon-download" @click="exporttrialrecord(value2)">正式导出</el-button>
      </span>
      <el-table :data="codeData" border v-if="selectproject === '试用锁记录'">
        <el-table-column label="加密锁号" prop="innerEncryptNo" width="150px"></el-table-column>
        <el-table-column label="创建日期" prop="createTime" width="200px" sortable></el-table-column>
        <el-table-column label="单位名称" prop="companyName" width="300px"></el-table-column>
        <el-table-column label="用户" prop="userName" width="100px"></el-table-column>
        <el-table-column label="产品详情">
          <template slot-scope="props" v-if="selectproject === '试用锁记录'">
            <el-table :data="props.row.modules">
              <el-table-column label="产品名称" prop="moduleName"></el-table-column>
              <el-table-column label="许可次数" prop="number"></el-table-column>
              <el-table-column label="节点" prop="node"></el-table-column>
              <el-table-column label="天/时间" prop="expiryDate"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="codeData" border v-if="selectproject === '正式锁记录'">
        <el-table-column label="合同编号" prop="contractNo" width="200px"></el-table-column>
        <el-table-column label="合同日期" prop="contractDate" width="200px"></el-table-column>
        <el-table-column label="单位名称" prop="companyName" width="300px"></el-table-column>
        <el-table-column label="外部锁号" prop="encryptNo" width="100px"></el-table-column>
        <el-table-column label="内部锁号" prop="innerEncryptNo" width="150px"></el-table-column>
        <el-table-column label="产品详情" prop="moduleStr"></el-table-column>
        <el-table-column label="更新日期" prop="updateTime" width="200px"></el-table-column>
        <el-table-column label="用户" prop="userName" width="100px"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, sizes, total, jumper"
        :total="totalCount"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pagesize"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as FileSaver from "file-saver";
export default {
  data() {
    return {
      value2: "",
      pagesize: 10,
      currpage: 1,
      totalPage: 0,
      totalCount: 0,
      selectproject: "试用锁记录",
      options: [
        {
          value: "试用锁记录",
          label: "试用锁记录",
        },
        {
          value: "正式锁记录",
          label: "正式锁记录",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      codeData: [],
    };
  },
  methods: {
    clearcodedata() {
      this.codeData = [];
      this.value2 = "";
      this.totalPage = 0;
      this.currpage = 1;
      this.totalCount = 0;
    },
    Getcodemeter(time) {
      if (time) {
        let formData = new FormData();
        formData.append("beginTime", String(time[0]));
        formData.append("endTime", String(time[1]));
        if (this.selectproject === "试用锁记录") {
          this.$http
            .post(this.$getaxiosurl("/enc/trial/getTrialRecord"), formData)
            .then((response) => {
              this.totalPage = response.data.data.totalPage;
              this.currpage = response.data.data.cpage;
              this.totalCount = response.data.data.totalCount;
              this.codeData = response.data.data.recordList;
            });
        } else {
          this.$http
            .post(this.$getaxiosurl("/enc/encrypt/queryNormalRecord"), formData)
            .then((response) => {
              this.totalPage = response.data.data.totalPage;
              this.currpage = response.data.data.cpage;
              this.totalCount = response.data.data.totalCount;
              this.codeData = response.data.data.recordList;
            });
        }
      } else {
        this.$message({
          message: "请选择查询日期",
          type: "error",
        });
      }
    },
    exporttrialrecord(time) {
      if (!time) {
        this.$message({
          message: "请选择查询日期",
          type: "error",
        });
        return;
      }
      let formData = new FormData();
      formData.append("beginTime", String(time[0]));
      formData.append("endTime", String(time[1]));
      if (this.selectproject === "试用锁记录") {
        this.$http
          .post(this.$getaxiosurl("/enc/trial/exportTrialRecord"), formData, {
            responseType: "blob",
          })
          .then((res) => {
            console.log(res);
            const blob = new Blob([res.data]);
            FileSaver.saveAs(blob, "试用加密锁记录.xlsx");
          });
      } else {
        this.$http
          .post(this.$getaxiosurl("/enc/encrypt/exportRecord"), formData, {
            responseType: "blob",
          })
          .then((res) => {
            const blob = new Blob([res.data]);
            FileSaver.saveAs(blob, "正式加密锁记录.xlsx");
          });
      }
    },
    handleCurrentChange(cpage) {
      let formData = new FormData();
      formData.append("pageSize", Number(this.pagesize));
      formData.append("cpage", Number(cpage));
      formData.append("beginTime", String(this.value2[0]));
      formData.append("endTime", String(this.value2[1]));
      if (this.selectproject === "试用锁记录") {
        this.$http
          .post(this.$getaxiosurl("/enc/trial/getTrialRecord"), formData)
          .then((response) => {
            if (response.data.code == "00100") {
              this.currpage = response.data.data.cpage;
              this.totalPage = response.data.data.totalCount;
              this.codeData = response.data.data.recordList;
            } else {
              this.$message({
                message: response.data.msg,
                type: "success",
                duration: 8000,
              });
            }
          });
      } else {
        this.$http
          .post(this.$getaxiosurl("/enc/encrypt/queryNormalRecord"), formData)
          .then((response) => {
            if (response.data.code == "00100") {
              this.currpage = response.data.data.cpage;
              this.totalPage = response.data.data.totalCount;
              this.codeData = response.data.data.recordList;
            } else {
              this.$message({
                message: response.data.msg,
                type: "success",
                duration: 8000,
              });
            }
          });
      }
    },
    //切换每页显示条数
    handleSizeChange(psize) {
      let formData = new FormData();
      formData.append("pageSize", Number(psize));
      formData.append("cpage", Number(this.currpage));
      formData.append("beginTime", String(this.value2[0]));
      formData.append("endTime", String(this.value2[1]));
      if (this.selectproject === "试用锁记录") {
        this.$http
          .post(this.$getaxiosurl("/enc/trial/getTrialRecord"), formData)
          .then((response) => {
            if (response.data.code == "00100") {
              this.currpage = response.data.data.cpage;
              this.totalPage = response.data.data.totalCount;
              this.pagesize = response.data.data.pageSize;
              this.codeData = response.data.data.recordList;
            } else {
              this.$message({
                message: response.data.msg,
                type: "success",
                duration: 8000,
              });
            }
          });
      } else {
        this.$http
          .post(this.$getaxiosurl("/enc/encrypt/queryNormalRecord"), formData)
          .then((response) => {
            if (response.data.code == "00100") {
              this.currpage = response.data.data.cpage;
              this.totalPage = response.data.data.totalCount;
              this.pagesize = response.data.data.pageSize;
              this.codeData = response.data.data.recordList;
            } else {
              this.$message({
                message: response.data.msg,
                type: "success",
                duration: 8000,
              });
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.el-range-editor.el-input__inner {
  margin-top: 11px;
  margin-bottom: 11px;
}
</style>
